import React from 'react';
import { DAY_MS } from '../../utils/dates';

/* Traka jednog dana (0–24 h) u bojama aktivnosti — isti izgled kao "Dani listića" u Bulk listićima (.dan-traka, .trace-seg),
   da su boje aktivnosti iste svuda u aplikaciji. Detalji su u zidnom vremenu (Date), dan = datum aktivnosti. */
const KLASA = { driving: 'driving', availability: 'availability', work: 'work', 'break/rest': 'rest', unknown: 'unknown' };
const SATI = [0, 3, 6, 9, 12, 15, 18, 21, 24];
const hm = (ms) => { const m = Math.round(ms / 60000); return m >= 1440 ? '24:00' : `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`; };

export default function TrakaDana({ details, day, naslov = 'Dan' }) {
    const d0 = new Date(day);
    const pocetak = new Date(d0.getFullYear(), d0.getMonth(), d0.getDate()).getTime();
    const delovi = (details || []).map((x) => {
        const od = Math.max(0, new Date(x.startTime).getTime() - pocetak);
        const kraj = Math.min(DAY_MS, new Date(x.endTime).getTime() - pocetak);
        return { type: x.activityType, od, do: kraj };
    }).filter((x) => x.do > x.od);
    const pct = (ms) => `${(ms / DAY_MS) * 100}%`;
    return (
        <div className="dan-trake traka-dana">
            <div className="dan-sati" aria-hidden="true">{SATI.map((h) => <span key={h} style={{ left: `${(h / 24) * 100}%` }}>{h}</span>)}</div>
            <div className="dan-traka">
                <span className="dan-traka-naslov">{naslov}</span>
                <div className="dan-traka-bar">
                    {delovi.map((x, i) => (
                        <span key={i} className={`trace-seg ${KLASA[x.type] || 'unknown'}`} style={{ left: pct(x.od), width: pct(x.do - x.od) }}
                            title={`${hm(x.od)}–${hm(x.do)}`} />
                    ))}
                    {!delovi.length && <span className="dan-traka-prazno">nema aktivnosti</span>}
                </div>
            </div>
        </div>
    );
}
